import { TagType } from "../../../types/bucketTypes"
import { Button } from "@weirgroup/weir-dls";
import { DisplayMap } from '../../map/map';
import { useNavigate } from "react-router-dom";
import { routePath } from "../../../constants/navigation.constants";
import { useTranslation } from "react-i18next";

interface Props {
    tagData: TagType | undefined;
}

export const LocationsTab = (props: Props) => {
    const { tagData } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();

    const goToLocationHistoryPage = () => {
        navigate(routePath.LOCATION_HISTORY);
    }

    return (
        <div className="locations-tab">
            {tagData?.location !== null ?
                <>
                    <p className="title">Current Location</p>
                    <DisplayMap tagData={tagData} />
                    <div className="view-history-btn">
                        <Button
                            label={'View Location History'}
                            size={'sm'}
                            onClick={() => goToLocationHistoryPage()}
                            full={false}
                            variant={'primary'}
                            canvasDeviceSize={'none'}
                        />
                    </div>
                </>
                :
                <p className="noLocationData">{t("noLocationData")}</p>
            }
        </div>
    )
}